import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationUser } from '../models/application-user.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}

  getAuth(): Observable<ApplicationUser> {
    return this.http.get<ApplicationUser>(`${environment.apiUrl}auth/user`, { withCredentials: true });
  }

  login(loginObj: any) {
    return this.http.post<any>(`${environment.apiUrl}auth/login`, loginObj, { withCredentials: true });
  }

  signOut() {
    return this.http.post<any>(`${environment.apiUrl}auth/logout`, {}, { withCredentials: true });
  }

  forgotPassword(email: string) {
    return this.http.post<any>(`${environment.apiUrl}auth/forgot-password?email=${email}`, null);
  }

  validateToken(token: string, uid: string) {
    return this.http.get<boolean>(`${environment.apiUrl}auth/validate-token?uid=${uid}&token=${token}`);
  }

  resetPassword(token: string, uid: string, passwords: any) {
    return this.http.post<any>(`${environment.apiUrl}auth/reset-password?uid=${uid}&token=${encodeURIComponent(token)}`, passwords);
  }

  changePassword(passwords: any) {
    return this.http.post<any>(`${environment.apiUrl}auth/change-password`, passwords, { withCredentials: true });
  }
}
